/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} All_ProvincesInputs */

const th_all_provinces = /** @type {(inputs: All_ProvincesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ทุกจังหวัด`)
};

const en_all_provinces = /** @type {(inputs: All_ProvincesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`All provinces`)
};

const ja_all_provinces = /** @type {(inputs: All_ProvincesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`すべての県`)
};

const zh_all_provinces = /** @type {(inputs: All_ProvincesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`全部府`)
};

const es_all_provinces = /** @type {(inputs: All_ProvincesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Todas las provincias`)
};

const pt_all_provinces = /** @type {(inputs: All_ProvincesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Todas as províncias`)
};

const id_all_provinces = /** @type {(inputs: All_ProvincesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Semua provinsi`)
};

const fr_all_provinces = /** @type {(inputs: All_ProvincesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Toutes les provinces`)
};

const tl_all_provinces = /** @type {(inputs: All_ProvincesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lahat ng lalawigan`)
};

const vi_all_provinces = /** @type {(inputs: All_ProvincesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mọi tỉnh`)
};

const ko_all_provinces = /** @type {(inputs: All_ProvincesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`전체 주`)
};

const de_all_provinces = /** @type {(inputs: All_ProvincesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alle Provinzen`)
};

const ru_all_provinces = /** @type {(inputs: All_ProvincesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Все провинции`)
};

const tr_all_provinces = /** @type {(inputs: All_ProvincesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tüm iller`)
};

const it_all_provinces = /** @type {(inputs: All_ProvincesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tutte le province`)
};

const pl_all_provinces = /** @type {(inputs: All_ProvincesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wszystkie prowincje`)
};

const uk_all_provinces = /** @type {(inputs: All_ProvincesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Усі провінції`)
};

const hi_all_provinces = /** @type {(inputs: All_ProvincesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`सभी प्रांत`)
};

const ar_all_provinces = /** @type {(inputs: All_ProvincesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`كل المحافظات`)
};

const ms_all_provinces = /** @type {(inputs: All_ProvincesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Semua wilayah`)
};

const bn_all_provinces = /** @type {(inputs: All_ProvincesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`সব প্রদেশ`)
};

const zh_tw2_all_provinces = /** @type {(inputs: All_ProvincesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`所有府`)
};

const zh_hk2_all_provinces = /** @type {(inputs: All_ProvincesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`所有府`)
};

const ur_all_provinces = /** @type {(inputs: All_ProvincesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تمام صوبے`)
};

const fa_all_provinces = /** @type {(inputs: All_ProvincesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`همهٔ استان‌ها`)
};

const sw_all_provinces = /** @type {(inputs: All_ProvincesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mikoa yote`)
};

const nl_all_provinces = /** @type {(inputs: All_ProvincesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alle provincies`)
};

/**
* | output |
* | --- |
* | "All provinces" |
*
* @param {All_ProvincesInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const all_provinces = /** @type {((inputs?: All_ProvincesInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<All_ProvincesInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_all_provinces(inputs)
	if (locale === "ja") return ja_all_provinces(inputs)
	if (locale === "zh") return zh_all_provinces(inputs)
	if (locale === "es") return es_all_provinces(inputs)
	if (locale === "pt") return pt_all_provinces(inputs)
	if (locale === "id") return id_all_provinces(inputs)
	if (locale === "fr") return fr_all_provinces(inputs)
	if (locale === "tl") return tl_all_provinces(inputs)
	if (locale === "vi") return vi_all_provinces(inputs)
	if (locale === "ko") return ko_all_provinces(inputs)
	if (locale === "de") return de_all_provinces(inputs)
	if (locale === "ru") return ru_all_provinces(inputs)
	if (locale === "tr") return tr_all_provinces(inputs)
	if (locale === "it") return it_all_provinces(inputs)
	if (locale === "pl") return pl_all_provinces(inputs)
	if (locale === "uk") return uk_all_provinces(inputs)
	if (locale === "hi") return hi_all_provinces(inputs)
	if (locale === "ar") return ar_all_provinces(inputs)
	if (locale === "ms") return ms_all_provinces(inputs)
	if (locale === "bn") return bn_all_provinces(inputs)
	if (locale === "zh-TW") return zh_tw2_all_provinces(inputs)
	if (locale === "zh-HK") return zh_hk2_all_provinces(inputs)
	if (locale === "ur") return ur_all_provinces(inputs)
	if (locale === "fa") return fa_all_provinces(inputs)
	if (locale === "sw") return sw_all_provinces(inputs)
	if (locale === "nl") return nl_all_provinces(inputs)
	return en_all_provinces(inputs)
});